// 峰会议程 6月12日
export const SUMMIT_DAY_2 = {
  title: '6月12日',
  day: 'DAY 2',
  host: '主会场',
  report: '第一报告厅',
  content: [
    {
      time: '9:30-11:45',
      title: 'openEuler分论坛',
      content: '本次OpenAtom openEuler分论坛以“万涓汇流，奔涌向前”为主题，邀请社区核心成员、重磅用户以及行业大咖分享开源操作系统与产业结合的技术创新和最佳落地实践。将为业界充分展示 openEuler 开源项目的运作成果，传递开源开放的 openEuler 发展模式。',
      speaker: '',
      schedule: '主题日程（拟定）',
      // guest: '演讲嘉宾（拟邀）',
      scheduleList: [
        {
          time: '9:30-9:40',
          content: [
            '**领导致辞**',
          ],
        },
        {
          time: '9:40-9:55',
          content: [
            '**《基础软件生态发展的溢出价值研究报告》发布**',
            '**戎珂**  清华大学社科学院经济研究所副所长、清华大学社科学院长聘教授',
          ],
        },
        {
          time: '9:55-10:05',
          content: [
            '**openEuler汇众智，奔涌向前赢未来**',
            '**江大勇**  openEuler委员会主席',
          ],
        },
        {
          time: '10:05-10:10',
          content: [
            '**openEuler项目群接受捐赠意向签约仪式**',
          ],
        },
        {
          time: '10:10-10:25',
          content: [
            '**openEuler打造行业首选的全场景融合操作系统**',
            '**熊伟**  开放原子开源基金会TOC副主席、openEuler技术委员会委员',
          ],
        },
        {
          time: '10:25-10:35',
          content: [
            '**麒麟信安操作系统助力水电站能源监控系统创新应用**',
            '**王攀**  麒麟信安副总裁',
            '**何婷**  北京中水科水电科技开发有限公司监控事业部新能源工程主任',
          ],
        },
        {
          time: '10:35-10:45',
          content: [
            '**润和软件HopeStage助力高校教务系统平台创新发展**',
            '**马建军**  润和软件云计算事业部解决方案总监',
            '**周杰**  智教育平台产品解决方案总监',
          ],
        },
        {
          time: '10:45-10:55',
          content: [
            '**夯实“数字底座”，麒麟软件助力金融行业自主创新能力提升**',
            '**杨汇成**  麒麟软件产品与社区发展中心副总经理',
          ],
        },
        {
          time: '10:55-11:05',
          content: [
            '**统信软件在金融行业的创新与应用**',
            '**任紫东**  统信软件解决方案中心资深专家',
          ],
        },
        {
          time: '11:05-11:15',
          content: [
            '**软通动力给使用openEuler社区版行业客户提供商业服务**',
            '**张先民**  软通动力基础软件事业部总裁',
          ],
        },
        {
          time: '11:15-11:25',
          content: [
            '**恒生电子基于openEuler的金融场景的应用实践**',
            '**许欣芃**  恒生电子总裁助理、技术平台产品总监',
          ],
        },
        {
          time: '11:25-11:35',
          content: [
            '**超聚变操作系统助力证券行业打造超低时延的高频量化交易平台**',
            '**刘恺**  超聚变数字技术有限公司操作系统首席架构师',
          ],
        },
        {
          time: '11:35-11:40',
          content: [
            '**openEuler Call for Meetup计划启动**',
          ],
        },
      ],
      peopleImage: 'https://res.oafimg.cn/-/08436eae2c84f2a3/output.jpg',
      producerCounts: 1,
    },
    {
      time: '14:00-18:30',
      title: 'OpenHarmony分论坛',
      content: '全球范围内以新一代信息技术为代表的科技革命正加速演进，OpenHarmony 将在数字经济时代乘风破浪，以根技术创新驱动生态繁荣，打造使能千行百业的泛终端数字底座。',
      // speaker: '延军 | 云杉网络研发云杉网 VP',
      schedule: '主题日程（拟定）',
      guest: '演讲嘉宾（拟邀）',
      scheduleList: [
        {
          time: '14:00-14:15',
          content: [
            '**领导致辞**',
          ],
        },
        {
          time: '14:15-14:30',
          content: [
            '**开源产业前景展望**',
            '**沈昌祥**  中国工程院院士、信息系统工程专家',
          ],
        },
        {
          time: '14:30-14:50',
          content: [
            '**共建地图2.0发布仪式**',
          ],
        },
        {
          time: '14:50-15:20',
          content: [
            '**OpenHarmony打造下一代智能终端操作系统根社区**',
            '**柳晓见**  OpenHarmony项目群工作委员会委员、华为终端BG软件部副总裁',
            '**邱国华**  社区贡献个人，Cocos 引擎架构师',
            '**梁珍权**  社区贡献个人，深圳CA 产品研发总监',
          ],
        },
        {
          time: '15:20-15:35',
          content: [
            '**OpenHarmony安全委员会成立**',
            '**任奎**  OpenHarmony安全委员会理事长、浙江大学网络空间安全学院院长',
          ],
        },
        {
          time: '15:35-15:50',
          content: [
            '**OpenHarmony南北向兼容性成果展示**',
            '**黄然**  OpenHarmony兼容性工作组组长、华为终端图形专家',
          ],
        },
        {
          time: '15:50-16:05',
          content: [
            '**“一杆”点亮智慧城市建设新范式--基于OpenHarmony的智慧多功能杆实践**',
            '**刘菁**  深圳开鸿数字产业发展有限公司综合BG副总裁',
          ],
        },
        {
          time: '16:05-16:20',
          content: [
            '**OpenHarmony为医院药品管理安全保驾赋能**',
            '**李陶薇**  南京天奥智能医疗科技有限公司总经理',
          ],
        },
        {
          time: '16:20-16:35',
          content: [
            '**OpenHarmony的商显方案应用**',
            '**龙壤**  深圳市视美泰技术股份有限公司总裁助理兼营销中心总经理',
          ],
        },
        {
          time: '16:35-16:50',
          content: [
            '**OpenHarmony赋能专业音视频应用创新**',
            '**仝永波**  随锐科技集团轮值执行总裁兼首席产品官',
          ],
        },
        {
          time: '16:50-17:05',
          content: [
            '**OpenHarmony智慧交通行业实践分享---在鸿控制器在智慧隧道场景的应用**',
            '**周凯明**   湖南开鸿智谷数字产业发展有限公司智慧交通副总经理',
          ],
        },
        {
          time: '17:05-17:20',
          content: [
            '**基于OpenHarmony的普惠金融创新实践**',
            '**付庆**  深圳市证通电子股份有限公司OpenHarmony研究院副院长',
          ],
        },
        {
          time: '17:20-17:35',
          content: [
            '**“智”育未来——面向基础教育的OpenHarmony教育生态建设**',
            '**张蓓**  新东方教育科技集团智慧教育事业部副总经理',
          ],
        },
        {
          time: '17:35-18:05',
          content: [
            '**OpenHarmony 3.2 Release 先行示范仪式**',
            '福建联迪商用设备有限公司 智能POS终端AxPOS A8S',
            '江苏思行达信息技术有限公司 自助业务办理机',
            '江苏润开鸿数字科技有限公司  DAYU200开发平台、DAYU210开发平台',
            '鸿湖万联 (江苏) 科技发展有限公司  扬帆系列“技”开发板',
            '芯海科技（深圳）股份有限公司  人体成分分析仪 Pomelo P10 ',
            '深圳开鸿数字产业发展有限公司  工业平板',
            '广东九联科技股份有限公司 边缘计算机ERK101',
          ],
        },
        {
          time: '18:05-18:30',
          content: [
            '**生态贡献致谢授牌**',
          ],
        },
      ],
      peopleImage: 'https://res.oafimg.cn/-/9cd0e46335479fce/output.jpg',
      producerCounts: 1,
    },
  ],

  branch: [
    {
      divide: '分会场1',
      day: 'DAY 2',
      report: '会议室AB',
      content: [
        {
          time: '9:00-12:00',
          title: '开源工业软件分论坛',
          content: '论坛以“开源赋能 工业铸魂”为主题，邀请开源工业软件  领域产学研代表分享开源工业软件国内外发展现状以及项目开源实践探索，共同探讨工业软件内核技术创新、科学难题攻关、开源集成框架及工具链发展思路，并发布最新研究成果和创新平台，为广大开源爱好者提供交流合作平台，推动我国开源工业软件生态繁荣发展。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '9:00-9:05',
              content: [
                '**主持人介绍大会领导和嘉宾**',
              ],
            },
            {
              time: '9:05-9:15',
              content: [
                '**领导致辞**',
              ],
            },
            {
              time: '9:15-09:45',
              content: [
                '**《开源工业软件白皮书结构优化》**',
                '**郭旭**  开源工业软件工作委员会主席、大连理工大学教授',
                '**《开源工业软件白皮FastCAE—CAE软件集成框架》**',
                '**唐滨**  开源工业软件工作委员会SIG7组长、哈尔滨工程大学副教授',
              ],
            },
            {
              time: '9:45-09:55',
              content: [
                '**开源工业软件社区发布**',
                '**卞孟春**  开源工业软件工作委员会执行总监',
              ],
            },
            {
              time: '9:55-10:10',
              content: [
                '**等几何分析——攻克CAD/CAE“语言鸿沟”难题及高精度仿真应用**',
                '**徐岗**  杭州电子科技大学教授',
              ],
            },
            {
              time: '10:10-10:25',
              content: [
                '**原创工业操作系统SylixOS**',
                '**徐贵洲**  北京翼辉信息技术有限公司副总经理',
              ],
            },
            {
              time: '10:25-10:40',
              content: [
                '**UBML开源低代码社区构建繁荣工业软件生态**',
                '**郑伟波**  浪潮通用软件有限公司副总经理兼首席技术官',
              ],
            },
            {
              time: '10:40-10:55',
              content: [
                '**新一代科学计算与系统建模仿真平台MWORKS开放架构及开放社区MoHub**',
                '**周凡利**  苏州同元软控信息技术有限公司总经理',
              ],
            },
            {
              time: '10:55-11:10',
              content: [
                '**高性能数学库与导构计算软件栈进展**',
                '**张先轶**  澎峰（北京）科技有限公司创始人兼CEO',
              ],
            },
            {
              time: '11:10-12:00',
              content: [
                '**圆桌论坛**',
                '**主题：工业软件开源的发展与思考**',
                '**主持人：卞孟春**  开源工业软件工作委员会执行总监',
                '**蒋涛**  CSDN创始人、极客帮基金创始合伙人',
                '**朱其罡**  开放原子开源基金会业务发展部部长',
                '**唐滨**  哈尔滨工程大学副教授',
                '**何先耀**  四川天府流体大数据研究中心风雷软件发展部部长',
                '**程进三**  中国科学院数学与系统科学院副研究员',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/4a37bba73156a604/output.jpg',
          producerCounts: 3,
        },
        {
          time: '13:30-17:30',
          title: '开源安全技术与实践分论坛',
          content: '本论坛将由开放原子开源基金会开源安全委员会举办，介绍开源安全委员会的工作成果，吸引企业和社区开源专家分享安全相关的技术方向和最佳实践，讨论开源安全领域最新产业动态。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '13:30-13:35', content: ['**领导致辞**'] },
            { time: '13:35-13:40', content: ['**开源安全委员会主席、副主席授牌**'] },
            {
              time: '13:40-13:55',
              content: ['**开源安全委员会进展与展望**', '**武延军**  中科院软件所副所长、总工'],
            },
            { time: '13:55-14:00', content: [
              '**新成员授牌**',
              '**武延军、任旭东、赵春雷** 开源安全委员会主席/副主席',
            ] },
            {
              time: '14:00-14:15',
              content: ['**开源安全测试工具的分析思路**', '**张磊**  统信软件 CTO'],
            },
            {
              time: '14:15-14:30',
              content: [
                '**When AI meets DevSecOps**',
                '**Yang LIU**  南洋理工大学计算机科学与工程学院教授、网络安全实验室主任',
              ],
            },
            {
              time: '14:30-14:45',
              content: ['**xAST引擎能力评价体系**', '**余瞰**  蚂蚁集团高级安全专家'],
            },
            {
              time: '14:45-15:00',
              content: ['**UVSCAN：检测物联网固件中的第三方组件使用违规**', '**纪守领**  浙江大学研究员'],
            },
            {
              time: '15:00-15:15',
              content: ['**开源软件漏洞情报共享的思考与实践**', '**云雷**  工信部电子五所软件研究院政策与技术研究室主任'],
            },
            {
              time: '15:15-15:30',
              content: [
                '**openEuler社区安全能力建设实践：为国内操作系统开源根社区健康发展保驾护航**',
                '**魏刚**  openEuler开源安全委员会主席',
              ],
            },
            {
              time: '15:30-16:15',
              content: [
                '**Panel**',
                '**武延军**  开源安全委员会主席',
                '**任旭东**  开源安全委员会副主席',
                '**赵春雷**  开源安全委员会副主席',
                '**Liu Yang** 南洋理工大学教授',
                '**纪守领**  浙江大学“百人计划”研究员、博士生导师、浙江大学滨江研究院国产信创研究中心副主任',
                '**平雷**   国家能源集团数据中心网络安全中心副总经理',
              ],
            },
            {
              time: '16:15-16:30',
              content: ['**开源软件供应链安全实践与思考**', '**韩建**  奇安信科技集团代码安全事业部负责人'],
            },
            {
              time: '16:30-16:45',
              content: ['**开源软件安全风险治理思路**', '**王振兴**  深信服千里目安全技术中心 CTO'],
            },
            {
              time: '16:45-17:00',
              content: ['**软件供应链安全保障与评估**', '**袁薇**  中国软件评测中心软件供应链技术专家'],
            },
            {
              time: '17:00-17:15',
              content: ['**开源及供应链安全产业洞察与实践分享**', '**张锐刚**  华为云产业战略官'],
            },
            { time: '17:15-17:30', content: [
              '**开源软件供应链可信风险分析与消解**',
              '**王潮** 深开鸿未来研究院副研究员',
            ] },
          ],
          peopleImage: 'https://res.oafimg.cn/-/fc5652218121f7a2/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场2',
      day: 'DAY 2',
      report: '会议室C',
      content: [
        {
          time: '9:00-12:00',
          title: '开源数据库分论坛',
          content: '本次论坛将围绕“开源开放生态如何推动数据库技术自主创新”这一主题，展开深入地讨论和探索。我们将邀请行业专家、开源社区领导者和数据库领域专家分享他们的见解和经验，共同探讨开源数据库未来的可能性和挑战。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '9:00-9:05', content: ['**主持人开场**'] },
            { time: '9:05-9:20', content: ['**领导致辞**'] },
            {
              time: '9:20-9:40',
              content: ['**主旨演讲：开源数据库的发展与挑战**', '**李卫**  国家工业信息安全发展研究中心软件所副所长'],
            },
            {
              time: '09:40-10:00',
              content: ['**主旨演讲：走向云和智能，全球开源数据技术应用趋势**', '**黄东旭**  平凯星辰联合创始人兼 CTO'],
            },
            {
              time: '10:00-10:20',
              content: [
                '**主旨演讲：瑶池PolarDB：打造有全球影响力的云原生开源数据库**',
                '**李飞飞**  阿里巴巴集团副总裁、阿里云智能数据库事业部总负责人',
              ],
            },
            {
              time: '10:20-10:40',
              content: ['**主旨演讲：平安科技基于开源数据库的创新实践**', '**汪洋**  平安科技数据库总工程师'],
            },
            {
              time: '10:40-11:00',
              content: [
                '**主旨演讲：openGemini：开源分布式时序数据库技术探索与实践**',
                '**张文亮**  华为云数据库创新实验室主任、华为云数据库首席创新专家',
              ],
            },
            {
              time: '11:00-11:20',
              content: ['**主旨演讲：腾讯TDSQL助力企业数字化转型**', '**王义成**  腾讯云数据库副总经理'],
            },
            {
              time: '11:20-11:40',
              content: ['**主旨演讲：GreatSQL社区，做中国广受欢迎的开源数据库**', '**娄帅**  万里数据库 CTO'],
            },
            {
              time: '11:40-12:00',
              content: [
                '**主旨演讲：构建物联网时代“快人一步”的 AIoT 数据库**',
                '**魏可伟**  浪潮 KaiwuDB CTO',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/1fb66dce367b6762/output.jpg',
          producerCounts: 1,
        },
        {
          time: '14:00-17:20',
          title: '先进计算分论坛',
          content: '本分论坛将涉及算力领域的最新技术和最佳实践，为助力我国超算、智算、算力一张网等算力领域的建设，我们特别邀请相关领域的专业人士，分享他们的技术和经验。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            {
              time: '14:00-14:20',
              content: ['**由基金会确定**', '**张云泉**  第十四届全国政协委员，中北大学计算机科学与技术学院（大数据学院）院长'],
            },
            {
              time: '14:20-14:40',
              content: ['**QUICKPOOL算力调度系统产品介绍**', '**苏斌**  北京华恒盛世科技有限公司总经理'],
            },
            {
              time: '14:40-15:00',
              content: ['**灵犀易算云一-构建开放、协同、警荣的算力生态系统**', '**潘景山**  国家超级计算济南中心副主任/济南超级计算技术研究院院长'],
            },
            {
              time: '15:00-15:20',
              content: ['**联通AI智算平台能力建设与行业应用**', '**樊利安**  联通数字科技有限公司数据智能事业部技术总监'],
            },
            { time: '15:20-15:40', content: [
              '**云原生助力先进计算节能减排**',
              '**华勇** 世纪互联云原生平台高级开发总监',
            ] },
            {
              time: '15:40-16:00',
              content: ['**LoongArch基础软件生态**', '**靳国杰**  龙芯中科技术有限公司 总裁助理、信创总监'],
            },
            {
              time: '16:00-16:20',
              content: [
                '**曦思®N100高性能人工智能推理GPU及其开源生态建设**',
                '**杨建**  沐曦集成电路（上海）有限公司 联合传创始人兼CTO',
              ],
            },
            {
              time: '16:20-16:40',
              content: ['**泛联信息-定义数据新速度**', '**孙宪臣**  深圳市泛联信息科技有限公司存储架构总监'],
            },
            {
              time: '16:40-17:00',
              content: [
                '**中科院万里红面向业务的数据安全防护体系**',
                '**姜国通**  北京万里红科技有限公司技术总监',
              ],
            },
            {
              time: '16:40-17:00',
              content: [
                '**云端超算，即刻开始 —— 开源 Cloud HPC 平台   HPC-NOW**',
                '**王真容**  上海即算科技有限公司 创始人，CEO',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/df5137c10bfcee82/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场3',
      day: 'DAY 2',
      report: '会议室DE',
      content: [
        {
          time: '9:00-11:45',
          title: '开源协作平台分论坛',
          content: '开源协作平台不仅是代码托管，而是一系列工具的集合，诸如Code Review、CI/CD、CloudIDE、代码扫描、漏洞检测等。欢迎大家分享开源协同中各种工具的实践经验。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '9:00-9:05', content: ['**基金会领导致辞**'] },
            {
              time: '9:05-9:15',
              content: ['**《AtomGit的诞生，发展和未来》**', '**冯冠霖**  开放原子开源基金会秘书长'],
            },
            {
              time: '9:15-9:30',
              content: ['**《开源协同，AtomGit制造》**', '**蒋鑫**  阿里云资深技术专家，Git开源项目贡献者'],
            },
            {
              time: '9:30-10:00',
              content: [
                '**《“云”力觉醒，基于云构建的分布式开源基础设施》**',
                '**滕龙**  阿里云高级技术专家，Git和Gerrit社区贡献者',
                '**陈博俊**  阿里云技术专家，Git社区贡献者',
              ],
            },
            {
              time: '10:10-10:30',
              content: [
                '**Gitea - 我们是如何获得3万6千颗星的**',
                '**肖伦文**  Gitea社区创建人, 上海吉谛科技有限公司CEO',
              ],
            },
            {
              time: '10:30-10:50',
              content: ['**《做优代码托管平台，助力开源基础设施高质量发展》**', '**陈平**  工信部电子五所软件与系统研究部(院)科研创新部主任'],
            },
            {
              time: '10:50-11:10',
              content: [
                '**《OpenSumi X AtomGit：WebIDE 与代码托管的合作实践》**',
                '**谢俊鸿**  OpenSumi 开源负责人与核心开发者，蚂蚁集团云研发团队成员',
              ],
            },
            {
              time: '11:10-11:30',
              content: [
                '**《AtomHub-打造中国云原生制品分发平台》**',
                '**许世威**  华为云高级工程师 华为云云原生团队核心成员，KubeEdge社区核心开发者，Kubernetes和Kubeflow社区核心贡献者',
              ],
            },
            {
              time: '11:30-11:45',
              content: ['**《打造社区中的社区 助力开源项目运营》**', '**闫辉** CSDN战略合作总监，开发者研究院院长'],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/cdc6073cf2f25882/output.jpg',
          producerCounts: 1,
        },
        {
          time: '14:00-18:00',
          title: 'CARSMOS开源智能出行生态年会',
          content: '智能出行和自动驾驶产业已进入快速成长阶段，但技术隔离式竞争不利于产业发展。本分论坛将汇聚成熟开源技术，以开源之力凝聚产学研力量，构建产业生态。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '14:00-14:05', content: [
              '**领导致辞**',
            ] },
            {
              time: '14:05-14:20',
              content: [
                '**主持人开场&智能出行中的开源大趋势**',
                '**CARSMOS2023开源算法大赛介绍和信息发布**',
                '**杨子江教授**'],
            },
            {
              time: '14:20-14:40',
              content: ['**开源的产学研联合，以及开源教育的现状和挑战**', '**周明辉**  北京大学教授/CCF开源委员会副主任'],
            },
            {
              time: '14:40-15:00',
              content: ['**长安汽车开放生态新策略**', '**韩三楚**  长安汽车首席软件架构师、长安科技首席技术官CTO'],
            },
            {
              time: '15:00-15:20',
              content: ['**Vehicle OS 开源和国标架构及产业实践**', '**尚进**  国汽智控 CEO兼CTO'],
            },
            {
              time: '15:20-15:40',
              content: ['**自动驾驶标准化及开源合作展望**', '**孙栋**  IEEE自动驾驶标准组主席、Futurewei技术副总裁'],
            },
            {
              time: '15:40-16:00',
              content: ['**OASIS-开源自动驾驶仿真系统**', '**潘余曦** 深信科创首席技术官CTO'],
            },
            {
              time: '16:00-16:20',
              content: ['**DORA-开源自动驾驶操作系统中间件**', '**何勇** Futurewei Technologies'],
            },
            {
              time: '16:20-16:40',
              content: ['**汽车软件开源开放平台的实践之路**', '**滕召智**  OpenSDV联盟技术生态负责人'],
            },
            {
              time: '16:40-17:00',
              content: ['**下一代汽车电子架构与整车硬件平台**', '**徐匡一** 江苏波霎科技有限公司创始人、俄罗斯工程院外籍院士'],

            },
            {
              time: '17:00-17:20',
              content: ['**开源自动驾驶换电/储能/数据交换**', '**Liu，Tin Hang** Open Motors CEO'],
            },
            {
              time: '17:20-17:40',
              content: ['**CARSMOS元遨开源社区治理与发展**', '**李伟军**  CARSMOS工作组执行总监'],
            },
            {
              time: '17:40-18:00',
              content: ['**基于OpenHarmony在交通领域的应用实践**', '**朱悦**  深开鸿交通BG解决方案总监'],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/a87a841162b671fb/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场4',
      day: 'DAY 2',
      report: '信创园：经开区国家信创园会议中心9号楼一层会场',
      content: [
        {
          time: '09:00-12:00',
          title: '开源社区治理与运营分论坛',
          content: '本论坛将从开源社区的发展历程、运营治理模式、项目治理、开源策略、治理工具、开源开发者生态等方面深度剖析，希望通过此次分享交流，让更多的组织、社区和项目获得更好地发展。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '9:00-9:05', content: ['**主持人开场**'] },
            {
              time: '9:05-9:25',
              content: [
                '**Open Innovations in Open Source Governance**',
                '**Bryan Che**  华为开源首席战略官、Eclipse基金会董事',
              ],
            },
            {
              time: '9:25-9:45',
              content: ['**全球开源社区治理现状与趋势**', '**Hong Phuc Dang**  FOSSASIA创始人'],
            },
            {
              time: '9:45-10:05',
              content: ['**AI新范式下的开源社区治理与运营**', '**于邦旭**  CSDN高级副总裁'],
            },
            {
              time: '10:05-10:25',
              content: ['**木兰开源社区发展与治理**', '**杨丽蕴**  中国电子技术标准化研究院研究室主任'],
            },
            {
              time: '10:25-10:45',
              content: [
                '**开源治理标准化建设发展与实践**',
                '**王伟** 华东师范大学数据科学与工程学院教授',
              ],
            },
            {
              time: '10:45-11:05',
              content: [
                '**夜莺的开源孵化和社区治理实践**',
                '**来炜**  快猫星云创始人，开源项目夜莺监控（Nightingale) 创始人',
              ],
            },
            {
              time: '11:05-11:25',
              content: [
                '**秉持开源初心,砥砺前行- TencentOS Tiny 开源项目成长之路**',
                '**汪礼超**  腾讯高级工程师、TencentOS Tiny开源项目负责人',
              ],
            },
            {
              time: '11:25-12:10',
              content: [
                '**开源圆桌派：如何把握开源社区治理的尺度？**',
                '**唐小引(主持人)**  CSDN《新程员》执行总编',
                '**杨丽蕴**  中国电子技术标准化研究院研究室主任',
                '**王伟**  华东师范大学数据科学与工程学院教授',
                '**王潮**  深开鸿未来研究院副研究员',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/a08b2beb5484fd9a/13.jpg',
          producerCounts: 1,
        },
        {
          time: '14:00-17:00',
          title: '软件物料清单分论坛',
          content: '本论坛将联合产业各界，围绕软件物料清单的技术创新、安全发展、成果实践、行业应用等方面进行交流，加强产业链上下游联动，推动完善开源软件供应链安全治理体系，促进SBOM生态发展。',
          speaker: '',
          schedule: '主题日程（拟定）',
          guest: '演讲嘉宾（拟邀）',
          scheduleList: [
            { time: '14:20-14:30', content: ['**主持人开场**'] },
            { time: '14:30-14:40', content: ['**领导致辞**'] },
            {
              time: '14:45-14:55',
              content: [
                '**SBOM工具揭榜行动启动仪式**',
              ],
            },
            {
              time: '14:55-15:10',
              content: [
                '**SBOM发展观察报告**',
                '**李卫**  国家工业信息安全发展研究中心软件所副所长',
              ],
            },
            {
              time: '15:10-15:25',
              content: [
                '**国内外软件供应链发展的挑战及应对**',
                '**陈钟**  北京大学计算机系教授、软微学院创始院长',
              ],
            },
            {
              time: '15:25-15:40',
              content: [
                '**开源供应链与SBOM**',
                '**吴敬征**  中科院软件所研究员',
              ],
            },
            {
              time: '15:40-15:55',
              content: [
                '**开源社区治理中SBOM发挥的关键作用—OpenChain项目**',
                '**Shane Coughlan**  Linux基金会OpenChain总经理',
              ],
            },
            {
              time: '15:55-16:10',
              content: [
                '**AI 数据BOM 的优秀实践分享**',
                '**高琨**  华为开源管理中心专家',
              ],
            },
            {
              time: '16:10-16:25',
              content: [
                '**操作系统开源社区SBOM治理特点**',
                '**王悦良**  OpenKylin社区合规SIG Maintainer',
              ],
            },
            {
              time: '16:25-16:40',
              content: [
                '**SBOM的安全价值——漏洞防范与响应**',
                '**姚珊**  360集团未来安全研究院副院长、大数据协同安全技术国家工程研究中心副主任',
              ],
            },
            {
              time: '16:40-16:55',
              content: [
                '**金融行业SBOM的探索与实践**',
                '**胡达川**  北京金融科技产业联盟主任',
              ],
            },
            {
              time: '16:55-17:10',
              content: [
                '**SBOM与开源许可证合规**',
                '**侯广**  北京桓润律师事务所合伙人',
              ],
            },
            {
              time: '17:10-17:40',
              content: [
                '**圆桌沙龙: 打造应对软件供应链风险的第一防线--SBOM实践探讨**',
                '**孙海龙**  北京航空航天大学软件学院教授',
                '**刘波**  openEuler软件供应链安全高级总监',
                '**马华兵**  华为云化网络开源首席专家',
                '**朱贤曼**  安势信息架构总监',
                '**龙文选**  LFAPAC开源布道者，奇科厚德副总经理',
              ],
            },
          ],
          peopleImage: 'https://res.oafimg.cn/-/4410294d0211fd8d/output.jpg',
          producerCounts: 1,
        },
      ],
    },
    {
      divide: '分会场5',
      day: 'DAY 2',
      report: '一楼贵宾接待室',
      content: [
        {
          time: '14:00-17:30',
          title: '“科创有招·招私募享”优质科创企业线下路演会',
          content: '开放原子开源基金会联合招商银行北京分行开展“科创有招·招私募享”优质科创企业线下路演会活动，对于在开源领域颇有建树的5-6家优质科创企业与20家以上的行业投资人搭建企业展示与投融资交流平台。',
          speaker: '',
          schedule: '主题日程（拟定）',
          scheduleList: [
            {
              time: '14:00-14:10',
              content: [
                '**主持人开场**',
              ],
            },
            {
              time: '14:10-14:30',
              content: [
                '**头部PE/VC投资人行业主题分享**',
              ],
            },
            {
              time: '14:30-14:45',
              content: [
                '**路演企业:北京华恒盛世科技有限公司**',
              ],
            },
            {
              time: '14:45-15:00',
              content: [
                '**路演企业: 南京鹏云网络科技有限公司**',
              ],
            },
            {
              time: '15:00-15:15',
              content: [
                '**路演企业: Open Motors**',
              ],
            },
            {
              time: '15:15-15:40',
              content: [
                '**茶歇**',
              ],
            },
            {
              time: '15:40-15:55',
              content: [
                '**路演企业: 上海即算科技有限公司**',
              ],
            },
            {
              time: '15:55-16:10',
              content: [
                '**路演企业: 英捷创软科技(北京)有限公司**',
              ],
            },
            {
              time: '16:10-16:25',
              content: [
                '**路演企业: 北京虚实视界科技有限公司**',
              ],
            },
            {
              time: '16:25-16:45',
              content: [
                '**演讲: 招商银行-科创企业尊享一体化服务方案**',
              ],
            },
            {
              time: '16:45-17:30',
              content: [
                '**自由交流**',
              ],
            },
          ],
          guest: '演讲嘉宾（拟邀）',
          peopleImage: 'https://res.oafimg.cn/-/daf00a275a819917/output.jpg',
          producerCounts: 0,
        },
      ],
    },
  ],
}
